import { render, staticRenderFns } from "./_datalimit.vue?vue&type=template&id=a66297ea&scoped=true&"
import script from "./_datalimit.vue?vue&type=script&lang=js&"
export * from "./_datalimit.vue?vue&type=script&lang=js&"
import style0 from "./_datalimit.vue?vue&type=style&index=0&id=a66297ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66297ea",
  null
  
)

export default component.exports